import { IApplicationState, TBoardId, TCardId, TCustomPropertyId } from '../../../../../types/types';
import { ICard } from '../../../../../store/model/card/types';
import { TColorTagColor } from '../../../../../types/model';
import { EUserMetaAssignedToMeSortField } from '../../../../../types/rest/IUserMeta';
import { ICardCell } from '../../../main/myWorkView/cards/types';

export interface IListViewBoard {
    collapsedGroups: TCardId[];
    isBlocked: boolean;
    isCollapsed: boolean;
    isGroupByEpics: boolean;
    isMobile: boolean;
    orderType: IOrderType | null;
    printMode: boolean;
    shownFields: TCardField[];
}

export interface ITreeFlat {
    cardIds: TCardId[];
    maxLevel: number;
}

export interface ICardsTree {
    [cardId: string]: ICardsTree;
}

export interface IOrderType {
    field: TCardField;
    isAsc: boolean;
    sortFunction?: TCardFieldSortFunction;
}

export enum ECardField {
    TITLE = 'title',
    // DESCRIPTION = 'description',
    PRIORITY = 'priority',
    PROGRESS = 'progress',
    LIST = 'list',
    TAGS = 'tags',
    START_DATE = 'startDate',
    DUE_DATE = 'dueDate',
    ESTIMATE = 'estimate',
    SPENT_TIME = 'spentTime',
    RELATED_CARDS = 'relatedCards',
    CHECKLIST = 'checklist',
    ATTACHMENTS = 'attachments',
    COMMENTS = 'comments',
    ASSIGNEES = 'assignees',
    CREATED = 'created',
}

export type TCardField = ECardField | TCustomPropertyId;

export type TCardFieldSortFunction = (
    state: IApplicationState,
    boardId: TBoardId,
    cardA: IListViewCard,
    cardB: IListViewCard,
    orderType: IOrderType,
) => number;

export interface ICardField {
    isHideable: boolean;
    isShownByDefault: boolean;
    isShown?: boolean;
    width: number;
    title: string;
    sortField: string;
    sortFunction: TCardFieldSortFunction;
    value: TCardField;
}

export type TCardFields = {
    [cardField: string]: ICardField;
};

export interface IColorTag {
    id?: any;
    color?: TColorTagColor;
    name?: string;
};

export interface IListViewCard extends ICard {
    listName?: string;
};
